import api from "./apiService";

export const getInterests = (data) => api().post(`/admin/getInterests`, data).then(response => response); 

export const addInterest = (data) => api().post(`/admin/addInterest`, data).then(response => response); 

export const updateInterest = (id, data) => api().put(`/admin/updateInterest/${id}`, data).then(response => response); 

export const removeInterest = (id, data) => api().delete(`/admin/removeInterest/${id}`).then(response => response); 

export const getInterestsOptions = () => api().get(`/admin/getInterestsOptions`).then(response => response); 

const services = {
    getInterests,
    addInterest,
    updateInterest,
    removeInterest ,
    getInterestsOptions 
}

export default services;